import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  CreateWebhookEventRequest,
  WrapperResponseWebhookDTO,
  WrapperResponseListWebhookDTO,
  WrapperResponseWebhookEventDTO,
  WrapperPageableResponseWebhookEventDTO,
  WrapperPageableResponseWebhookIntentDTO,
  WrapperResponse
} from '../core/models';

@Injectable({
  providedIn: 'root'
})
export class WebhookService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/webhooks`;

  listWebhooks(): Observable<WrapperResponseListWebhookDTO> {
    return this.http.get<WrapperResponseListWebhookDTO>(this.apiUrl);
  }

  getWebhook(id: number): Observable<WrapperResponseWebhookDTO> {
    return this.http.get<WrapperResponseWebhookDTO>(`${this.apiUrl}/${id}`);
  }

  createWebhook(request: CreateWebhookEventRequest): Observable<WrapperResponseWebhookDTO> {
    return this.http.post<WrapperResponseWebhookDTO>(this.apiUrl, request);
  }

  updateWebhook(id: number, request: CreateWebhookEventRequest): Observable<WrapperResponseWebhookDTO> {
    return this.http.put<WrapperResponseWebhookDTO>(`${this.apiUrl}/${id}`, request);
  }

  deleteWebhook(id: number): Observable<WrapperResponse<void>> {
    return this.http.delete<WrapperResponse<void>>(`${this.apiUrl}/${id}`);
  }

  listEvents(params: Record<string, unknown> = {}, pageable: { page?: number; size?: number; sort?: string[] } = {}): Observable<WrapperPageableResponseWebhookEventDTO> {
    let httpParams = new HttpParams();
    Object.entries({ ...params, ...pageable }).forEach(([key, value]) => {
      if (value != null && (Array.isArray(value) ? value.length > 0 : true)) {
        if (Array.isArray(value)) {
          value.forEach((v) => { httpParams = httpParams.append(key, String(v)); });
        } else {
          httpParams = httpParams.append(key, String(value));
        }
      }
    });
    return this.http.get<WrapperPageableResponseWebhookEventDTO>(`${this.apiUrl}/events`, { params: httpParams });
  }

  listIntents(eventId: number, pageable: { page?: number; size?: number; sort?: string[] } = {}): Observable<WrapperPageableResponseWebhookIntentDTO> {
    let httpParams = new HttpParams();
    Object.entries(pageable).forEach(([key, value]) => {
      if (value != null && (Array.isArray(value) ? value.length > 0 : true)) {
        if (Array.isArray(value)) {
          value.forEach((v) => { httpParams = httpParams.append(key, String(v)); });
        } else {
          httpParams = httpParams.append(key, String(value));
        }
      }
    });
    return this.http.get<WrapperPageableResponseWebhookIntentDTO>(`${this.apiUrl}/events/${eventId}/intents`, { params: httpParams });
  }

  resendEvent(eventId: number): Observable<WrapperResponseWebhookEventDTO> {
    return this.http.post<WrapperResponseWebhookEventDTO>(`${this.apiUrl}/events/${eventId}/resend`, {});
  }
}
